import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';
import '../../App.css';
import '../../css/bootstrap.scss';
import phoneno_icon from "../../images/phone_no.png";
import { Link } from 'react-router-dom';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import BackButton from '../Includes/BackButton';
import axios, { AxiosError } from 'axios';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { setEmail, setResetPasswordWizardPageNumber } from '../ResetPasswordReducer';
import { RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../config';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import SuccessOTPModal from '../Camera/SuccessOTPModal';
import { useTranslation } from 'react-i18next';

interface Props { };

const VerifyPhoneNo: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const email = useSelector((state: RootState) => state.resetPassword.email);
    const phoneNo = useSelector((state: RootState) => state.resetPassword.phoneNo);

    const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
    const [validated, setValidated] = useState(false);
    const sendotp_baseURL = config.NODE_API_BASE_URL + '/twillio/sendSMSOTP';
    const verifyotp_baseURL = config.NODE_API_BASE_URL + '/twillio/verifySMSOTP';

    var num1: any = useRef(null);
    var num2: any = useRef(null);
    var num3: any = useRef(null);
    var num4: any = useRef(null);
    var num5: any = useRef(null);
    var num6: any = useRef(null);

    const [showModal1, setShowModal1] = useState(false);

    const handleShowModal1 = () => {
        setShowModal1(true);
    };
    const handleCloseModal1 = async () => {
        setShowModal1(false);
    };

    const sendOTP = async (resend: Number) => {
        try {
            const sendOTP = await axios.post(sendotp_baseURL, {
                phoneNo: phoneNo
            }).catch((reason: AxiosError<{ additionalInfo: string }>) => {
                console.log(reason.response);
                if (reason.response?.status === 404) {
                    notifyError('OTP Failed');
                    fieldsEmpty();
                    return;
                } else if (reason.response?.status === 429) {
                    notifyError('Something Went Wrong');
                    fieldsEmpty();
                    return;
                } else {
                    notifyError('Something Went Wrong');
                    fieldsEmpty();
                    return;
                }
            });
            if (resend == 1) {
                notifySuccess("OTP Sent");
            }
            return sendOTP?.data;
        } catch (error: any) {
            console.error(error);
            fieldsEmpty();
        }
    };

    const handleOtpInput = (e: React.ChangeEvent<HTMLInputElement>, nextInputRef: React.RefObject<HTMLInputElement> | null) => {
        const input = e.target;
        const value = input.value;

        if (value.length === 1 && /^\d$/.test(value)) {
            if (nextInputRef && nextInputRef.current) {
                nextInputRef.current.focus();
            }
        } else {
            input.value = '';
        }
    };

    const fieldsEmpty = () => {
        num1.current.value = "";
        num2.current.value = "";
        num3.current.value = "";
        num4.current.value = "";
        num5.current.value = "";
        num6.current.value = "";
    };

    const verifyOTP = async (phoneNo: string, otpCode: string) => {
        try {
            const verifyOTP = await axios.post(verifyotp_baseURL, {
                phoneNo: phoneNo,
                otpCode: otpCode
            }).catch((reason: AxiosError<{ additionalInfo: string }>) => {
                console.log(reason.response?.status);
                if (reason.response?.status === 404) {
                    notifyError('Invalid OTP');
                    fieldsEmpty();
                    return;
                } else if (reason.response?.status === 429) {
                    notifyError('Something Went Wrong');
                    fieldsEmpty();
                    return;
                } else {
                    notifyError('Something Went Wrong');
                    fieldsEmpty();
                    return;
                }
            });
            return verifyOTP?.data;
        } catch (error: any) {
            console.error(error);
            fieldsEmpty();
        }
    };

    const submitForm = async (formValues: FormData) => {
        const userEnteredOtp = `${num1.current?.value}${num2.current?.value || ''}${num3.current?.value || ''}${num4.current?.value || ''}${num5.current?.value || ''}${num6.current?.value || ''}`;

        if (userEnteredOtp == '') {
            notifyError("Invalid OTP.");
            return;
        }
        const Response = await verifyOTP(phoneNo, userEnteredOtp);
        console.log("Response: ", Response);
        if (Response?.status == "approved") {
            handleShowModal1();
        } else {
            notifyError("Invalid OTP.");
        }
    };

    return (
        <>
            <Header />

            <SuccessOTPModal
                show={showModal1}
                handleClose={handleCloseModal1}
                title={t('camera.verification_completed')}
            />

            <ToastBox />
            <Container fluid className='min-vh-custom'>
                <Row className=''>
                    <Col md={3} className='text-center ms-2'>
                        <div className='mt-5 py-4 ms-5'>
                            <BackButton />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className='mt-5 text-center'>
                        <img src={phoneno_icon} width={50} />
                        <h3 className='text-center mt-3'>{t('login.verify_phone_title')}</h3>
                        <span className='fw-normal'>
                            {t('login.code_sent')} <br />
                            <span className='fw-bold'>{phoneNo} </span>
                            {t('login.code_valid')}{' '}
                            <Link className='text-primary' to={""}>{t('login.change_mobile')}</Link>
                        </span>
                        <p className='fs-5 mt-3 letter-spacing-fix'>{t('login.enter_code')}</p>

                        <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>
                            <div className="input-group d-flex justify-content-center">
                                <div className="input-group d-flex justify-content-center">
                                    <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num2)} ref={num1} className='rounded-4 border border-1 otp-input' />
                                    <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num3)} ref={num2} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} />
                                    <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num4)} ref={num3} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} />
                                    <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num5)} ref={num4} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} />
                                    <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num6)} ref={num5} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} />
                                    <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, null)} ref={num6} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} />
                                </div>
                            </div>
                            <div className='d-grid gap-2 col-md-3 mx-auto mt-4'>
                                <Button type="submit" className='btn btn-primary mt-3 rounded-5'>
                                    {t('common.submit')}
                                </Button>
                            </div>
                        </Form>
                        <div className='mt-3'>
                            <span>{t('common.didnt_receive')} <Link className='text-primary' to={""} onClick={() => sendOTP(1)}>{t('common.resend_code')}</Link></span>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Footer full={true} />
        </>
    );
};

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,
})(VerifyPhoneNo);

export default connect(null)(form);
